// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatawbnb } from "../../../icons/mono/build/icon-statawbnb.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatawbnbIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatawbnb.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatawbnbIcon.displayName = 'StatawbnbIcon';
}

export default StatawbnbIcon;